// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CookieNotice_wrapper__SIue5","actions":"CookieNotice_actions__3f7-W"};